import { render, staticRenderFns } from "./landingLayout.vue?vue&type=template&id=0953a78c&"
import script from "./landingLayout.vue?vue&type=script&lang=ts&"
export * from "./landingLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports